import { render } from "./create_product.vue?vue&type=template&id=c3d1db38&scoped=true"
import script from "./create_product.vue?vue&type=script&lang=js"
export * from "./create_product.vue?vue&type=script&lang=js"

import "./create_product.vue?vue&type=style&index=0&id=c3d1db38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3d1db38"]])

export default __exports__